import de from '@translations/de/loginForm.json';
import en from '@translations/en/loginForm.json';
import pl from '@translations/pl/loginForm.json';
import sl from '@translations/sl/loginForm.json';
import uk from '@translations/uk/loginForm.json';
import bg from '@translations/bg/loginForm.json';
import cz from '@translations/cz/loginForm.json';
import fr from '@translations/fr/loginForm.json';
import gr from '@translations/gr/loginForm.json';
import it from '@translations/it/loginForm.json';
import pr from '@translations/pr/loginForm.json';
import ru from '@translations/ru/loginForm.json';
import sk from '@translations/sk/loginForm.json';
import sp from '@translations/sp/loginForm.json';
import tr from '@translations/tr/loginForm.json';
import hu from '@translations/hu/loginForm.json';
import { ITranslations } from '@/types/common';
import { LoginFormTransFields } from './types';

export const loginFormTranslations: ITranslations<LoginFormTransFields> = {
  name: 'loginForm',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
